module.exports = __webpack_public_path__ + "441b6f84fe11ecddaab5c631c9dfb14b.ttf";